import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const MeadowHeightsEmergencyDentistPage = () => (
  <ServiceLocationTemplate suburbName="Meadow Heights" suburbSlug="meadow-heights" variant="emergency-dentist" />
);

export default MeadowHeightsEmergencyDentistPage;
